import React from 'react';
import { Avatar, LinearProgress } from '@material-ui/core';
import styled from 'styled-components';

import { formatDate } from '../../../common/formatter';
import { JiraFieldConfig } from '../../jira-server/jira-server.interface';
import { JiraIssue } from '../JiraConnect.interface';
import { Link } from '@material-ui/core';

const StyledAvatar = styled.span`
  .avatar {
    width: 16px;
    height: 16px;
    float: left;
    margin-right: 5px;
  }
`;

export type JiraRenderedFieldProps = {
  issue: JiraIssue;
  config: JiraFieldConfig;
  baseUrl: string;
  isJiraServer: boolean;
};

const JiraRenderedField: React.FC<JiraRenderedFieldProps> = ({
  issue,
  config,
  baseUrl,
  isJiraServer
}) => {
  try {
    const field = issue.fields[config.fieldKey];
    switch (config.type) {
      case 'user':
        return (
          <StyledAvatar>
            <Avatar
              alt={field.displayName}
              src={field.avatarUrls['16x16']}
              className='avatar'
            />
            {isJiraServer ? (
              <a
                target='_blank'
                rel='noreferrer'
                href={`${baseUrl}/secure/ViewProfile.jspa?name=${field.name}`}
              >
                {field.displayName}
              </a>
            ) : (
              <Link
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  if (typeof AP?.navigator?.go === 'function') {
                    AP.navigator.go('userProfile', {
                      userAccountId: field.accountId
                    });
                  }
                }}
              >
                {field.displayName}
              </Link>
            )}
          </StyledAvatar>
        );
      case 'date':
        return <>{formatDate(field)}</>;
      case 'progress':
        const progress =
          field.total > 0 ? (field.progress / field.total) * 100 : 0;
        return <LinearProgress variant='determinate' value={progress} />;
      case 'attachment':
        return (
          <ul>
            {field.map((file: { content: string; filename: string }) => (
              <li>
                <a rel='noreferrer' href={file.content} target='_blank'>
                  {file.filename}
                </a>
              </li>
            ))}
          </ul>
        );
      default:
        // text
        return typeof field === 'object' ? (
          <span>{field.name}</span>
        ) : (
          <span>{field}</span>
        );
    }
  } catch (error) {
    console.debug('Error rendering jira field', issue, config);
    return <></>;
  }
};

export default JiraRenderedField;
